import { render } from "./BaseEmptyFeedState.vue?vue&type=template&id=b0dd1e2c&scoped=true"
import script from "./BaseEmptyFeedState.vue?vue&type=script&lang=js"
export * from "./BaseEmptyFeedState.vue?vue&type=script&lang=js"

import "./BaseEmptyFeedState.vue?vue&type=style&index=0&id=b0dd1e2c&scoped=true&lang=scss"

import exportComponent from "/opt/render/project/src/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b0dd1e2c"]])

export default __exports__